export const LANGUAGE_LOCAL_STORE_NAME = (userID?: string) => `wiz__language_id${userID ? `_${userID}` : ''}`;
export * from './language-switcher'
export * from './i18n-context-provider'